var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.5V20.5C15 21.3285 14.3285 22 13.5 22H4.079C3.207 22 2.5 21.293 2.5 20.421V7.5C2.5 6.6715 3.1715 6 4 6H9.8785C10.2765 6 10.658 6.158 10.939 6.439L14.707 10.207C14.7925 10.2925 14.861 10.392 14.91 10.5H11.5C10.9475 10.5 10.5 10.0525 10.5 9.5V6.25M16.5 2.5V6C16.5 6.5525 16.9475 7 17.5 7H21M17 19H20C20.8285 19 21.5 18.3285 21.5 17.5V7.6215C21.5 7.2235 21.342 6.842 21.0605 6.561L16.939 2.4395C16.658 2.158 16.2765 2 15.8785 2H9.5C8.6715 2 8 2.6715 8 3.5V4M5.5 14.5H12M5.5 16.5H12M5.5 18.5H9.5",
    stroke: "#3545DE",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyPhoto);
export default __webpack_public_path__ + "static/media/copyPhoto.664e2425a3071fc64b409bee9bebb32a.svg";
export { ForwardRef as ReactComponent };